const header = {
  'innovations': 'Innovations',
  'features': 'Fonctionnalités',
  'offers': 'Offres',
  'contact': 'Contact',
  'login': 'Se connecter',
}

export default header
